// Строки этой шторки, которых нет в 08_copy.md — тот же приём, что в
// modules/inbox/widgets/InboxList/config.ts: структурные подписи UI живут локально в конфиге
// виджета, а не хардкодом в разметке, и это кандидат на перенос в copy владельцем `lunya`.
export const CITY_POPULAR_OVERLINE = 'ПОПУЛЯРНЫЕ'
export const CITY_SEARCH_PLACEHOLDER = 'Найти город'
export const CITY_EMPTY_TITLE = 'Такого города я не нашла'
export const CITY_EMPTY_DESCRIPTION = 'Попробуй написать иначе — вдруг опечатка'

/** Галочка у выбранного города — размер иконок списка по 01 §5 (контур 20–24). */
export const CITY_SELECTED_ICON_SIZE = 18
export const CITY_SELECTED_ICON_STROKE = 1.8
